import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { TestimonialsSection2 } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalPurchaseSection } from './components/FinalPurchaseSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1274277057465018');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-black font-sans" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductShowcase data-id="element-4" />
      <Bonuses data-id="element-5" />
      <PurchaseSection data-id="element-6" />
      <Guarantee data-id="element-7" />
      <TestimonialsSection2 data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalPurchaseSection data-id="element-10" />
      <Footer data-id="element-11" />

      <SocialProofPopup data-id="element-12" />
      <StickyMobileCTA data-id="element-13" />

      <noscript data-id="element-14">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1274277057465018&ev=PageView&noscript=1" alt="" data-id="element-15" />
      </noscript>
    </div>;
}